/**
 * Utah: who to call at each local health department (moved from deptcontact.ts with the state packs, 2026-10-02).
 *
 * Who to call: the phone number of a Utah local health department, from the sourced department data ONLY.
 *
 * Source: docs/marketing/seo/utah-local.json, `departments[].contact.phone` with its `contact_source`, all `verified: true`, opened 2026-09-29
 * (research in docs/marketing/seo/UTAH-LOCAL-RESEARCH.md; the quotes are in docs/source/research/special-process.md, row SP16). The department
 * ids and county lists are the ones in localrules-ut.ts (13 departments). Nothing here is invented: a test reads the JSON and checks that
 * every digit string below is in it, under the same department, and that every Utah county resolves to a number.
 *
 * Some departments list one number per office. The department's own page names the town of each office, and the county follows the town:
 *  - Southeast Utah: Price (Carbon County), Moab (Grand County), Castle Dale (Emery County);
 *  - Central Utah: its page lists the counties with each number (Sevier, Piute and Wayne; Sanpete; Juab and Millard);
 *  - Southwest Utah: its page lists "Main (435) 986-2580" and the counties of the other two numbers (Iron, Beaver and Garfield; Kane);
 *    Washington County, the rest, takes the main number.
 * A county whose department is unknown, or a place with no county, gets no number: the caller says "your county health department".
 */
import type { DeptContact } from "../deptcontact.ts";

export const UT_DEPT_CONTACTS: readonly DeptContact[] = [
  { department: "bear-river", phone: "(435) 792-6570", office: "Logan Environmental Health Building" },
  { department: "central-utah", phone: "435-896-5451", counties: ["Sevier", "Piute", "Wayne"] },
  { department: "central-utah", phone: "435-835-2231", counties: ["Sanpete"] },
  { department: "central-utah", phone: "435-623-0696", counties: ["Juab", "Millard"] },
  { department: "davis", phone: "801-525-5120" },
  { department: "salt-lake", phone: "385-468-3845" },
  { department: "san-juan", phone: "435-587-3838" },
  { department: "southeast-utah", phone: "(435) 637-3671", office: "Price", counties: ["Carbon"] },
  { department: "southeast-utah", phone: "(435) 259-5602", office: "Moab", counties: ["Grand"] },
  { department: "southeast-utah", phone: "(435) 381-2252", office: "Castle Dale", counties: ["Emery"] },
  { department: "southwest-utah", phone: "(435) 865-5154", counties: ["Iron", "Beaver", "Garfield"] },
  { department: "southwest-utah", phone: "(435) 296-5477", counties: ["Kane"] },
  { department: "southwest-utah", phone: "(435) 986-2580" },
  { department: "summit", phone: "435-333-1502", office: "Environmental Health" },
  { department: "tooele", phone: "435-277-2440" },
  { department: "tricounty", phone: "435-247-1169", office: "Vernal" },
  { department: "utah-county", phone: "(801) 851-7525" },
  { department: "wasatch", phone: "435-657-3303" },
  { department: "weber-morgan", phone: "(801) 399-7160" },
];
